export enum OrganizationFlags {
    ADMIN_CLIENT = 1,
    TOP_LEVEL = 2,
    PUBLISHER = 4,
    HAS_CHILDREN = 8,
    HAS_SHARED = 16
};

export enum License {
    SPOT_AUDIO = 'SPOT.AUDIO',
    SPOT_SCENT = 'SPOT.SCENT',
    SPOT_VIDEO = 'SPOT.VIDEO'
};